
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const baseUrl = window.location.origin;
const apiUrl = "__API_URL__";

export const userManager = new UserManager({
  authority: `${apiUrl}/proarc-sts`,
  client_id: "PROARC-EXT",

  redirect_uri: `${baseUrl}/callback`,
  post_logout_redirect_uri: `${baseUrl}/proarc-ext/*`,

  response_type: "code",

  // ✅ IMPORTANT
  scope: "openid profile offline_access",

  // ✅ disable iframe-based renew
  automaticSilentRenew: true,
  monitorSession: false,

  userStore: new WebStorageStateStore({
    store: window.localStorage
  })
});
